import axios from "axios"

export const AppSync = axios.create({
  baseURL: process.env.AWS_APPSYNC_URL,
  headers: {
    "x-api-key": process.env.AWS_APPSYNC_APIKEY
  },
})